<template>
  <div class="box">
    <!-- 默认地址 -->
    <div v-if="showDataAddress=='hideAddress'"
         @click="onEdit"
         style="font-size:.26rem;line-height:.8rem;background:#fff">
      <div
           style="display:flex;justify-content:space-between;align-items:center;padding:.15rem .15rem .15rem .2rem ">
        <p style="letter-spacing: .02rem;">请您先填写收货地址哦..</p>
        <van-icon style="padding-right:.1rem"
                  name="arrow" />
      </div>
      <img style="height:.06rem;width: 100%;"
           src="../../assets/borderBot.png" />
    </div>
    <div v-if="showDataAddress=='showAddress'"
         class="addressCard"
         style="display:flex;align-items:center">
      <van-radio-group @change="radioAddressBtn"
                       v-model="radioSince"
                       style="margin-right:.2rem">
        <van-radio name="1"
                   checked-color="#FF355C"></van-radio>
      </van-radio-group>
      <!-- 支付页新增编辑地址 -->
      <div style="display:flex;flex-direction:column;color:#333">
        <div
             style="display:flex;justify-content:flex-start;padding-top:.2rem;align-items: center;">
          <p>
            {{address.address_name ? address.address_name : addressinfo[0].address_name}}
          </p>&nbsp;&nbsp;&nbsp;
          <p>{{address.phone ? address.phone : addressinfo[0].phone}}</p>
        </div>
        <div @click="onEdit"
             style="display:flex;justify-content:space-between;width:100%">
          <div style="display:flex;justify-content:flex-start;">
            <p class="box_pt box-pf">
              {{address.site_info ? address.site_info : addressinfo[0].site_info}}
            </p>
          </div>
          <van-icon style="padding-right:.1rem"
                    name="arrow" />
        </div>
      </div>
    </div>
    <!-- 到店自提 -->
    <div v-if="sinceList.length > 0 && this.showData == 'show'"
         class="sinc-smlBox">
      <div style="display:flex;align-items: center;">
        <div style="margin-right:.2rem">
          <van-radio-group @change="radioAddressBtn"
                           v-model="radioSince">
            <van-radio name="2"
                       checked-color="#FF355C"></van-radio>
          </van-radio-group>
        </div>
        <div>
          <div
               style="display:flex;justify-content:flex-start;padding-top:.2rem;align-items: center;">
            <p><span
                    style="color:#ff355c">自提免运费&nbsp;&nbsp;</span>{{sinceChecked!='' ? sinceChecked.address_name : sinceList[0].address_name}}
            </p>&nbsp;&nbsp;&nbsp;
            <p>
              {{sinceChecked!='' && sinceList[0].phone!='' ? sinceChecked.phone : sinceList[0].phone}}
            </p>
          </div>
          <div @click="onSinceEdit"
               style="display:flex;justify-content:space-between;width:100%">
            <div style="display:flex;justify-content:flex-start;">
              <p class="box_pt"
                 style="padding:.2rem 0;font-size:.22rem;color:#bfbfbf">
                {{sinceChecked!='' ? sinceChecked.site_info : sinceList[0].site_info}}
              </p>
            </div>
            <van-icon v-if="sinceList.length>1"
                      name="arrow" />
          </div>
        </div>
      </div>
    </div>
    <!-- 购物车现金积分详情 -->
    <div v-if="shopCart.length > 0"
         v-for="(item,i) in shopCart"
         :key="i"
         class="addressCard1"
         style="padding:.2rem">
      <div><img :src="item.pd_img" /></div>
      <div style="display:flex;flex-direction:column;color:#333;width:100%">
        <p class="spece-name pd-name">{{item.pd_name}}</p>
        <p class="spece-name spece-only"><span
                :class="!item.specs ? 'showSpecs' : 'none'">规格：</span>{{item.specs}}
        </p>
        <div style="display:flex;justify-content: space-between;">
          <p style="margin-bottom:0rem;color:#FF355C;font-size:.24rem">
            <span
                  v-if="item.buy_type == 0">{{configInfo.cash_name || '现金'}}:￥{{item.pd_price}}</span>
            <span
                  v-if="item.buy_type == 1">{{configInfo.points_price_name || '积分'}}:{{item.pd_points}}</span>
            <span
                  v-if="item.buy_type == 2">{{configInfo.cash_name || '现金'}}:￥{{item.pd_price}}&nbsp;&nbsp;{{configInfo.points_price_name || '积分'}}:{{item.pd_points}}</span>
          </p>
          <p style="display: flex;justify-content: flex-end;">x
            {{item.pd_count}}</p>
        </div>
      </div>
    </div>
    <!-- 非购物车 -->
    <div v-if="!shopCart.length">
      <div class="addressCard1">
        <!-- 有规格 -->
        <div v-if="shopPayDetail.is_specs == 1">
          <img
               :src="shopPaySkuproduc.img ? shopPaySkuproduc.img : shopPayDetail.img_json.split('|')[0]" />
        </div>
        <!-- 无规格 -->
        <div v-else>
          <img
               :src="shopPayDetail.img_json?shopPayDetail.img_json.split('|')[0]:''" />
        </div>
        <div style="display:flex;flex-direction:column;color:#333">
          <p class="spece-name pd-name">{{shopPayDetail.pd_name}}</p>
          <p class="spece-name spece-only"><span
                  :class="shopPayDetail.is_specs != 1 ? 'showSpecs' : 'none'">规格：</span>{{shopPayDetail.is_specs == 1 ? shopPaySkuproduc.specs:''}}
          </p>
          <p v-if="shopPayDetail.is_specs == 1"
             style="margin-bottom:0.05rem 0;color:#FF355C;font-size:.24rem">
            <span
                  v-if="shopPayDetail.buy_type == 0">{{configInfo.cash_name || '现金'}}:￥{{shopPaySkuproduc.pd_price}}</span>
            <span
                  v-if="shopPayDetail.buy_type == 1">{{configInfo.points_price_name || '积分'}}:{{shopPaySkuproduc.pd_points}}</span>
            <span
                  v-if="shopPayDetail.buy_type == 2">{{configInfo.cash_name || '现金'}}:￥{{shopPaySkuproduc.pd_price}}&nbsp;&nbsp;{{configInfo.points_price_name || '积分'}}:{{shopPaySkuproduc.pd_points}}</span>
          </p>
          <p v-if="shopPayDetail.is_specs != 1"
             style="margin-bottom:0.05rem 0;color:#FF355C;font-size:.24rem">
            <span
                  v-if="shopPayDetail.buy_type == 0">{{configInfo.cash_name || '现金'}}:￥{{shopPayDetail.pd_price}}</span>
            <span
                  v-if="shopPayDetail.buy_type == 1">{{configInfo.points_price_name || '积分'}}:{{shopPayDetail.pd_points}}</span>
            <span
                  v-if="shopPayDetail.buy_type == 2">{{configInfo.cash_name || '现金'}}:￥{{shopPayDetail.pd_price}}&nbsp;&nbsp;{{configInfo.points_price_name || '积分'}}:{{shopPayDetail.pd_points}}</span>
          </p>
        </div>
      </div>
      <div class="shopspec3">
        <p>购买数量</p>
        <div style="margin: .2rem;">
          <!-- :min="detailShop.buy_min_num" -->
          <van-stepper v-model="num"
                       @change="bunIpt"
                       @plus='addBtn'
                       @minus='reductionBtn'
                       :max='detailShop.buy_max_num == 0 ? detailShop.stockpile : detailShop.buy_max_num'
                       :min="detailShop.buy_min_num"
                       integer
                       input-width="40px"
                       button-size="21px" />
        </div>
      </div>
    </div>
    <div class="shopspec3">
      <p>商品金额：</p>
      <p style="margin: .2rem;color:#666;">
        <span>￥{{Number(payNumMoney*1).toFixed(2)}}</span>
      </p>
    </div>
    <!-- 运费 -->
    <div v-if="(totalExpressFee >0 || shopFreightMoney > 0) && radioSince == '1'"
         class="shopspec3">
      <p>运费：</p>
      <p v-if="totalExpressFee > 0"
         style="margin: .2rem;color:#666;">
        <span v-if="discountType==0"
              :class="expressFee >= 0 ?'none' : 'underline'">￥{{Number(totalExpressFee).toFixed(2)}}</span>
        <!-- 模板包邮/不包邮 -->
        <span v-if="discountType==1"
              :class="expressFee > 0 ?'none' : 'underline'">￥{{Number(totalExpressFee).toFixed(2)}}</span>
        <!-- 满减包邮 -->
        <span v-if="discountType==2"
              :class="expressFee >= 0 ?'none' : 'underline'">￥{{Number(expressFee).toFixed(2)}}</span>
        <!-- 优惠券 -->
        <span v-if="discountType==3"
              class="underline">￥{{Number(totalExpressFee).toFixed(2)}}</span>
        <!-- 企业承担 -->
        <span>{{getDiscountType(discountType)}}</span>
      </p>
      <p v-else
         style="color:#666;"><span
              :class="expressFee >= 0 ?'none' : 'underline'">￥{{Number(shopFreightMoney).toFixed(2)}}</span><span>{{getDiscountType(discountType)}}</span>
      </p>
    </div>
    <!--兑换码 优惠券-->
    <div style="margin:.15rem 0"
         v-if="isShowRedeemCode">
      <ConversionCode ref="ConversionCode" @radioCouponBtn='radioCouponBtn'
                      :shopCartList="shopCartList"
                      :discountType='discountType'
                      :discountExpressFee='discountExpressFee'
                      @notUse='notUse'
                      :showDataAddress="showDataAddress"></ConversionCode>
    </div>
    <!--e卡支付列表-->
    <div style="margin:.15rem 0"
         v-if="isShowEList">
      <ConversionEList @radioCouponBtn='radioCouponBtn'
                       :shopCartList="shopCartList"
                       :discountType='discountType'
                       :discountExpressFee='discountExpressFee'
                       :showDataAddress="showDataAddress"></ConversionEList>
    </div>
    <!-- 支付方式不是积分 运费不是0 并且购物车列表长度大于0 v-if="shopPayDetail.buy_type!='1'|| shopFreightMoney!= 0 || shopCart.length > 0" -->
    <div class="payType">
      <div v-if="(payType != 4 && payType != 5  && disablePayMode != 1) || configInfo.cp_uid == '10267' || configInfo.cp_uid == '10277'"
           @click="payTypeBtn(1)"
           style="display:flex;justify-content:space-between;">
        <div style="display:flex;justify-content:flex-start">
          <img style="width: .3rem;"
               src="../../assets/weChat.png" />
          <p>微信支付</p>
        </div>
        <van-icon v-if="payType == 1"
                  size=".22rem"
                  name="success" />
      </div>
      <div v-if="(payType != 4 && payType != 5 && disablePayMode != 2) || configInfo.cp_uid == '10267' || configInfo.cp_uid == '10277'"
           @click="payTypeBtn(0)"
           style="display:flex;justify-content:space-between;">
        <div style="display:flex;justify-content:flex-start">
          <img style="width: .3rem;"
               src="../../assets/payTreasure.png" />
          <p>支付宝支付</p>
        </div>
        <van-icon v-if="payType == 0"
                  size=".22rem"
                  name="success" />
      </div>
      <div v-if="(payType == 4 || payType == 5) && configInfo.cp_uid != '10267' && configInfo.cp_uid != '10277'"
           style="display:flex;justify-content:space-between;border-bottom:.01rem solid rgba(204, 204, 204, 0.483);">
        <div style="display:flex;justify-content:flex-start">
          <img style="width: .3rem;"
               src="../../assets/weChat.png" />
          <p>微信支付</p>
        </div>
        <van-icon size=".22rem"
                  name="success" />
      </div>
    </div>
    <div class="shopClass">
      <!-- 购物车 -->
      <p v-if="shopCart.length > 0"
         style="font-size:.24rem;">
        <span
              v-if="radioSince == 1">{{configInfo.cash_name || '现金'}}:￥{{Number(countPrice*1+expressFee*1).toFixed(2)}}</span>
        <span
              v-if="radioSince == 2">{{configInfo.cash_name || '现金'}}:￥{{Number(countPrice*1).toFixed(2)}}</span>
        <span
              v-if="countPoints != 0">&nbsp;&nbsp;{{configInfo.points_price_name || '积分'}}:{{countPoints}}</span>
      </p>
      <!-- 普通商品，非购物车 -->
      <p v-if="!shopCart.length"
         style="font-size:.24rem">
        <!-- buy_type 0 现金 1 积分 2 现金+积分 -->
        <span
              v-if="radioSince == 1">{{configInfo.cash_name || '现金'}}:￥{{Number(payNumMoney*1+expressFee*1).toFixed(2)}}</span>
        <span
              v-if="radioSince == 2">{{configInfo.cash_name || '现金'}}:￥{{Number(payNumMoney*1).toFixed(2)}}</span>
        <span>{{configInfo.points_price_name || '积分'}}:{{payNumMoneyJF}}</span>
      </p>
    </div>
    <div style="display:flex;justify-content:center;font-size: .24rem;">
      <div class="detail-btn">
        <button v-if="showPay == false || payNumMoney > 0 || shopFreightMoney > 0"
                @click="payMoney"
                class="shop-btn">{{ isShowEList ? '立即下单' : '立即支付'}}</button>
      </div>
      <div class="detail-btn">
        <button v-if="showPay == true"
                @click="payMoney"
                class="shop-btn">正在支付</button>
      </div>
      <div class="detail-btn">
        <button v-if="!shopPayDetail.pd_price && shopFreightMoney==0"
                @click="payMoney"
                class="shop-btn">立即兑换</button>
      </div>
    </div>

    <!-- 地址弹框 -->
    <van-popup v-model="addressShow"
               position="bottom"
               :style="{ height: '50%' }"
               style="background: #f6f6f6;">
      <Address :address='address'
               @addressItem='addressItem'
               @closeAddress='closeAddress'></Address>
      <van-button @click="addAddress"
                  class="add-btn"
                  color="#f40259"
                  para
                  type="info"
                  size="large">新增收货地址</van-button>
    </van-popup>
    <!-- 到店自提 -->
    <van-popup v-model="sinceShow"
               position="bottom"
               :style="{ height: '50%' }"
               style="background: #f6f6f6;color: #333;">
      <div class="top-box">
        <div
             style="display:flex;justify-content:space-between;align-items: center;height: .8rem;">
          <p style="color:#fff">x</p>
          <p style="">选择自提地址</p>
          <van-icon @click="sinceShow = false"
                    name="cross"
                    size=".35rem"
                    style="padding-right:.2rem" />
        </div>
      </div>
      <div style="margin-top:1rem;line-height:.4rem">
        <div v-for="(item,i) in sinceList"
             :key="i"
             class="since-smlbox">
          <div style="display:flex;align-items: center;">
            <div @click="sinceBtn(item)"
                 style="margin-right:.2rem">
              <van-radio-group v-model="radioAddress">
                <van-radio :name="i"
                           checked-color="#FF355C"></van-radio>
              </van-radio-group>
            </div>
            <div>
              <span>{{item.address_name}}</span>&nbsp;&nbsp;&nbsp;
              <span>{{item.phone}}</span>
              <span v-if="item.is_default == 1"
                    class="default">默认</span>
              <p class="address-info">{{item.site_info}}</p>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 自提地址绑定手机号 -->
    <van-dialog closeable
                v-model="showPhone"
                title="绑定手机号"
                closeOnClickOverlay
                :showConfirmButton='false'>
      <van-icon @click="closeDiolad"
                name="cross"
                style="position: fixed;top:.4rem;right: .4rem;" />
      <div class="since-box">
        <p style="color:#999;font-size:.22rem">请绑定手机号，以便接收自提验证码</p>
        <p style="font-size:.24rem;margin: .2rem 0 .1rem;">
          您当前手机号:{{userInfo.phone}}</p>
        <p style="font-size:.24rem">是否绑定此手机号绑定？</p>
        <div
             style="display:flex;margin-top: .3rem;justify-content: space-between;width:85%;">
          <button @click="cancelPhoneBtn"
                  color="#FF355C"
                  size="samll"
                  type="default"
                  class="surecancel-btn cancel-btn">更换</button>
          <button @click="surePhoneBtn"
                  color="#FF355C"
                  size="samll"
                  type="default"
                  class="surecancel-btn">使用</button>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="switchPhone"
                title="绑定手机号"
                :showConfirmButton='false'
                closeOnClickOverlay>
      <van-icon @click="closeDiolad"
                name="cross"
                style="position: fixed;top:.4rem;right: .4rem;" />
      <div class="since-box">
        <p style="color:#999;font-size:.22rem">请绑定手机号，以便接收自提验证码</p>
        <p style="margin: .3rem 0;font-size:.24rem">手机号：<input
                 @change="phoneIptBtn"
                 v-model="phoneIpt"
                 style="border-bottom: .01rem solid #d0d0d0;" /></p>
        <p style="font-size:.24rem;margin-bottom: .3rem;position: relative;">
          验证码：<input v-model="codeIpt"
                 @input='aptchaInterception'
                 style="border-bottom: .01rem solid #d0d0d0;" />
          <span v-if="verificationCode==''"
                @click="getCode(phoneIpt)"
                style="color:#FF355C;position: absolute;top: 0;right:0;">获取验证码</span>
          <span v-else
                style="color:#ff355c;position: absolute;top: 0;right: 0rem;">{{countdown}}s</span>
        </p>
        <van-button @click="beforeSwitchPhone"
                    color="#FF355C"
                    size="small"
                    type="default"
                    style="border-radius:.08rem;width:70%">确认</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="showSms"
                title="安全验证"
                :showConfirmButton="false"
                :closeOnClickOverlay="false">
      <van-icon @click="hideSms"
                name="cross"
                style="position: fixed;top:.4rem;right: .4rem;" />
      <div class="since-box2">
        <p
           style="width: 86%;font-size:.24rem;margin-bottom: .6rem;position: relative;">

          <input v-model="smsCode"
                 @input='smsCode = smsCode.substring(0, 6);'
                 placeholder="请输入验证码"
                 style="width: 65%; text-align: center;border-bottom: .01rem solid #d0d0d0;" />
          <span v-if="corpCode==''"
                @click="getCorpCode"
                style="color:#fff;position: absolute;top: -5px;right:0; border: 1px solid; padding: .05rem;background:#FF355C;border-radius: 3px;">获取验证码</span>
          <span v-else
                style="color:#ff355c;position: absolute;top: 0;right: 0rem;">{{countdown2min}}s</span>
        </p>
        <van-button @click="corpPayClick"
                    color="#FF355C"
                    size="small"
                    type="default"
                    style="border-radius:.08rem;width:70%">立即支付</van-button>
      </div>
    </van-dialog>
    <!-- 支付弹框 -->
    <div :show="showPay"></div>
    <!-- 配置 -->
    <GetConfig @appConfig='appConfig' />
    <div class="agreement"
         v-show="isAgreement">
      <p>支付功能与采集信息由“淘来云”提供，如有疑问请联系客服电话:4001186769</p>
    </div>
  </div>
</template>
<script>
import localStor from "../../utils/ls.js";
import Address from "../../components/address/Address";
import ConversionCode from "../../components/address//ConversionCode";
import ConversionEList from "../../components/address//ConversionEList";
import { isAddressId } from "../../utils/addressId";
import GetConfig from "../public//GetConfig";
import { getAddressinfo } from "../../utils/fun";
import { CellGroup } from "vant";
import base64 from "../../utils/base64";
export default {
  components: {
    Address,
    ConversionCode,
    ConversionEList,
    GetConfig,
  },
  data() {
    return {
      configInfo: JSON.parse(localStorage.getItem("configInfo")) || {},
      userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
      addressId: isAddressId.fetch(),
      showDataAddress: "",
      addressinfo: [],
      address: {}, //获取使用的那个地址
      radioAddress: 0,
      showPhone: false,
      switchPhone: false,
      phoneIpt: "",
      codeIpt: "",
      verificationCode: "",
      countdown: 60,
      timer: null,
      showEdit: false,
      isEdit: false,
      list: [],
      coupons: [], // 优惠券
      showList: false,
      addressShow: false,
      sinceShow: false,
      num: localStor.get("payNum"), // 商品数量
      payType: 1, //支付方式 0：支付宝 1：微信 4：公众号
      chosenAddressId: "1", //默认选中复选框
      shopPayDetail: localStor.get("payDetail"),
      shopFreightMoney: 0, //单品运费
      shopPaySkuproduc: localStor.get("skuproduc"), //规格对象
      cartShopArr: localStor.get("cartShopArr") || [], //购物车
      filterNewArr: [], //购物车
      detailShop: localStor.get("detailShop"), //最小购买数量
      list: [],
      payMonet: 0,
      payNumMoney: 0,
      payNumMoneyJF: 0,
      payNumMoneyStart: 0,
      payNumMoneyEnd: 0,
      userCouponFull: 0,
      userCouponAmount: 0,
      status: "",
      couponId: "",
      showPay: false,
      payTitle: "",
      flag: 0,
      payConfig: {},
      pathDiami: "",
      shopCart: localStor.get("result") || [], //购物车传来的商品
      countPrice: localStor.get("countPrice") || 0, //购物车传来的现金
      countPoints: localStor.get("countPoints") || 0, //购物车传来的商品
      sinceList: [],
      sinceChecked: "",
      radioSince: "1",
      showData: "",
      checkSinceId: "", //自提地址选中id
      checkAddressId: "", //选中配送地址id
      goShopId: localStor.get("goShopId") || [],
      phoneIptVal: "",
      codeObj: "",
      totalExpressFee: 0, //优惠前金额
      discountExpressFee: 0, //优惠值
      expressFee: 0, //优惠后金额
      discountType: 0, //包邮类型
      disablePayMode: 0, //禁用支付方式  0不禁用 1微信 2支付宝
      isCorpAddress: false,
      isShowRedeemCode: false,
      isShowEList: true,
      isPayStatus: true,
      shopCartList: [],
      coupon: "",
      cardPay: "",
      showSms: false,
      smsCode: "",
      orderId: "",
      corpCode: "",
      countdown2min: 60,
      cardPayNum: 0,
      points: 0,
      isAgreement: false,
    };
  },
  created() {
    if (this.configInfo.is_show_service_agreement == 1) {
      this.isAgreement = true;
    }
  },
  mounted() {
    if (this.shopCart.length > 0) {
      this.shopCartList = this.shopCart;
      for(let i = 0;i < this.shopCartList.length;i++) {
        this.shopCartList[i].pay_num = this.shopCartList[i].pd_count
      }
    } else {
      const arr = [];
      this.shopPayDetail.pay_num = this.num
      arr.push(this.shopPayDetail);
      this.shopCartList = arr;
    }
    this.getAddress(); // 地址列表
    this.getPayMonet(); //总金额
    this.configInfo.cp_uid != "10267" && this.configInfo.cp_uid != "10277" && this.isWeixn();
    this.getSince(); // 自提
    localStorage.removeItem("payType"); //移除支付方式
    this.deliverType(); // 判断虚拟 实物

    if ("corp_signfor_address" in this.configInfo && this.configInfo.corp_signfor_address) {
      this.isCorpAddress = true;
      this.corpAreaCode = this.configInfo.corp_signfor_address.split(",")[2];
    }

    this.isShowRedeemCode = this.configInfo.is_show_redeem_code == 1 ? true : false;
    this.isShowEList = this.configInfo.is_crop_ePay == 1 ? true : false;
  },
  destroyed() {
    //清除下监听事件 不过这段貌似没有什么用在微信浏览器里面
    window.removeEventListener("popstate", this.goBack, false);
  },

  methods: {
    // 不使用优惠券
    notUse() {
      // 购物车
      if (this.codeObj) {
        this.codeObj.exchangeCode = "";
        this.countPrice = localStor.get("countPrice");
        this.countPoints = localStor.get("countPoints");
      }

      //详情现金  有规格无规格
      if (this.shopPayDetail.is_specs == 1) {
        this.payNumMoney = Number(this.shopPaySkuproduc.pd_price * this.num).toFixed(2);
      } else {
        this.payNumMoney = Number(this.shopPayDetail.pd_price * this.num).toFixed(2);
      }
      // 详情积分
      if (this.shopPayDetail.is_specs == 1) {
        this.payNumMoneyJF = Number(this.shopPaySkuproduc.pd_points * this.num).toFixed(2);
      } else {
        this.payNumMoneyJF = Number(this.shopPayDetail.pd_points * this.num).toFixed(2);
      }
      this.coupon = "";
      this.getshopFreight();
      this.getPayMonet();
    },
    // 使用优惠券
    radioCouponBtn(obj) {
      this.codeObj = obj;
      // 购物车
      let price = localStor.get("countPrice") || 0;
      let points = localStor.get("countPoints") || 0;
      this.countPrice = Number(price) - Number(obj.couponPrice);
      this.countPoints = Number(points) - Number(obj.couponPoints);
      this.countPrice = this.countPrice.toFixed(2);
      this.countPoints = this.countPoints.toFixed(2);
      this.couponId = obj.couponExpress.id;
      if (typeof this.address != "undefined" && this.address.province_code) {
        this.getshopFreight(); //运费
      }
      this.coupon = obj;
      this.getPayMonet();
    },
    // 判断虚拟 实物  虚拟商品不显示自提地址
    deliverType() {
      if (Array.isArray(this.detailShop)) {
        this.showData = this.detailShop[0].deliver_type == 1 ? "show" : "hide";
      } else {
        this.showData = this.detailShop.deliver_type == 1 ? "show" : "hide";
      }
    },
    goBack() {
      this.$router.replace({
        Diamin: "/orderAll",
      });
    },
    pushHistory() {
      // 修改history
      let state = {
        title: "",
        url: "/orderAll", // 这个url可以随便 填，只是为了不让浏览器显示的url地址发生变化，对页面其实无影响,但是最好写页面当前的地址，因为这个地址他会默认替换你当前的地址 再次刷新会找不到页面
      };
      window.history.pushState(state, state.title, state.url);
    },
    closeAddress() {
      this.addressShow = false;
    },
    getDiscountType(discountType) {
      switch (discountType) {
        case 1:
          return (discountType = "(满减包邮)");
        // case 2:
        //   return discountType = "(优惠劵优惠)";
        case 3:
          return (discountType = "(企业承担)");
      }
    },
    // 切换地址
    addressItem(item) {
      isAddressId.save(item.id);
      this.address = item;
      this.provinceCode = item.province_code;
      this.cityCode = item.city_code;
      this.areaCode = item.area_code;
      this.addressShow = false;
      this.radioSince = "1";
      this.getshopFreight(); //运费
    },
    // 编辑地址
    onEdit(item, index) {
      this.addressShow = true;
    },
    // 自提地址
    onSinceEdit() {
      if (this.sinceList.length > 1) {
        this.sinceShow = true;
      }
    },
    // 选中的自提地址
    sinceBtn(item) {
      this.sinceShow = false;
      this.sinceChecked = item;
      this.checkSinceId = item.address_id;
      this.radioSince = "2";
      this.shopFreightMoney = 0;
      this.totalExpressFee = 0;
      this.getPayMonet();
    },
    // 新增收货地址
    addAddress() {
      this.$router.push({
        name: "ShopAddress",
        params: {
          queryId: 6,
        },
      });
    },
    // 自提
    getSince() {
      this.$axios({
        method: "POST",
        url: "/app/address/sinceTakeAddress",
        data: {},
        success: (data) => {
          if (data.data.status == "success") {
            this.sinceList = data.data.data;
          } else {
            this.$toast(data.data.message);
          }
        },
      });
    },
    // ipt框计数
    bunIpt() {
      this.getPayMonet();
      this.getshopFreight();
      this.shopPayDetail.pay_num = this.num
      this.$refs.ConversionCode.getData()
      if (this.num == this.shopPayDetail.buy_max_num - 1) {
        this.$toast("您已到达最大购买数量..");
        return;
      }
      if (this.num == this.shopPayDetail.buy_user_max_num - 1) {
        this.$toast("您已到达用户最大购买数量..");
        return;
      }
      if (this.num == this.shopPayDetail.buy_user_day_max_num - 1) {
        this.$toast("您已到达用户每天最大购买数量..");
        return;
      }
      if (this.num == this.shopPayDetail.buy_user_time_max_num - 1) {
        this.$toast("您已到达用户每次最大购买数量..");
        return;
      }
    },
    // 加
    addBtn() {
      this.num = this.num + 1;
      this.shopPayDetail.pay_num = this.num
      this.getPayMonet();
      this.$refs.ConversionCode.getData()
    },
    // 减
    reductionBtn() {
      if (this.num == 1) {
        this.$toast("商品不能再减少了..");
        return;
      }
      this.num = this.num - 1;
      this.shopPayDetail.pay_num = this.num
      this.getPayMonet();
      this.$refs.ConversionCode.getData()
    },
    // 总额
    getPayMonet() {
      const coupon = this.coupon;
      let price = 0;
      // 分别得到有规格和没规格的时候的 现金
      if (this.shopPayDetail.is_specs == 1) {
        if (this.shopPayDetail.buy_type == 1) {
          // 购买方式为积分，实付现金必须为0
          this.payNumMoney = Number(price).toFixed(2);
        } else {
          this.payNumMoney = Number(this.shopPaySkuproduc.pd_price * this.num).toFixed(2);
        }
      } else {
        if (this.shopPayDetail.buy_type == 1) {
          // 购买方式为积分，实付现金必须为0
          this.payNumMoney = Number(price).toFixed(2);
        } else {
          this.payNumMoney = Number(this.shopPayDetail.pd_price * this.num).toFixed(2);
        }
      }
      // 分别得到有规格和没规格的时候的 积分
      if (this.shopPayDetail.is_specs == 1) {
        this.payNumMoneyJF = Number(this.shopPaySkuproduc.pd_points * this.num).toFixed(2);
      } else {
        this.payNumMoneyJF = Number(this.shopPayDetail.pd_points * this.num).toFixed(2);
      }

      // console.log(coupon)

      // 纯现金中的现金值 满足 优惠券满减的时候
      if (coupon) {
        let payNumMoney = 0;
        // 使用额大于满减额并且是现金券
        if (this.payNumMoney * 1 >= coupon.couponPrice * 1 && coupon.couponExpress.coupon_denomination == "1") {
          //纯现金 = 现金减满减优惠券
          payNumMoney = this.payNumMoney - coupon.couponPrice;
          payNumMoney = Number(payNumMoney).toFixed(2);
        }

        // 使用额大于兑换码现金
        if (this.payNumMoney * 1 < coupon.couponPrice * 1 && coupon.couponExpress.coupon_denomination == "1") {
          payNumMoney = "0.00";
        }

        payNumMoney === 0 ? "" : (this.payNumMoney = payNumMoney);
      }

      // 纯积分中的积分值 满足 优惠券满减的时候
      if (coupon) {
        let payNumMoneyJF = 0;
        // 使用额大于满减额并且是积分券
        if (this.payNumMoneyJF * 1 >= coupon.couponPoints * 1 && coupon.couponExpress.coupon_denomination == "0") {
          //纯积分 = 积分减满减优惠券
          payNumMoneyJF = this.payNumMoneyJF - coupon.couponPoints;
          payNumMoneyJF = Number(payNumMoneyJF).toFixed(2);
        }
        // 使用额大于兑换码积分
        if (this.payNumMoneyJF * 1 < coupon.couponPoints * 1 && coupon.couponExpress.coupon_denomination == "0") {
          payNumMoneyJF = "0.00";
        }
        payNumMoneyJF === 0 ? "" : (this.payNumMoneyJF = payNumMoneyJF);
      }

      if (coupon) {
        if (coupon.couponExpress.coupon_attribute == 300 && coupon.couponExpress.coupon_type == 301) {
          if (coupon.couponExpress.coupon_denomination == 2) {
            this.payNumMoney = this.payNumMoney < coupon.couponPrice || coupon.couponPrice == 0 ? 0.0 : Number(this.payNumMoney - coupon.couponPrice).toFixed(2);
            this.payNumMoneyJF = this.payNumMoneyJF < coupon.couponPoints || coupon.couponPoints == 0 ? 0.0 : Number(this.payNumMoneyJF - coupon.couponPoints).toFixed(2);
          }
        }
        if (coupon.couponExpress.coupon_attribute == 300 && coupon.couponExpress.coupon_type == 302) {
          this.payNumMoneyJF = "0.00";
          this.payNumMoney = "0.00";
        }
      }
    },
    // 支付方式
    payTypeBtn(i) {
      this.payType = i;
    },
    // 运费
    getshopFreight() {
      if (this.$route.query.path != "ShoppingCart" && (this.$route.query.path != "shopAddress" || JSON.stringify(this.shopCart) == "{}")) {
        this.filterMainArr(); //详情页到支付页
      } else {
        this.filterCartArr();
      }
      this.$axios({
        method: "POST",
        url: "/app/express",
        data: {
          provinceId: typeof this.provinceCode == "undefined" ? this.address.province_code : this.provinceCode,
          cityId: typeof this.cityCode == "undefined" ? this.address.city_code : this.cityCode,
          areaId: typeof this.areaCode == "undefined" ? this.address.area_code : this.areaCode,
          items: JSON.stringify(this.cartShopArr),
        },
        success: (data) => {
          if (data.data.status == "success") {
            let dataObj = data.data.data;
            this.status = data.data.status;
            if (this.radioSince == "1") {
              // 不使用兑换码
              this.shopFreightMoney = dataObj ? dataObj.money : "";
              // 使用兑换码
              this.totalExpressFee = dataObj ? dataObj.totalExpressFee : ""; //优惠前金额
              this.discountExpressFee = dataObj ? dataObj.discountExpressFee : ""; //优惠值
              this.expressFee = dataObj ? dataObj.expressFee : ""; //优惠后金额
              this.discountType = dataObj ? dataObj.discountType : ""; //优惠后金额
              //判断企业是否设置运费
              for (let key in this.shopCartList) {
                if (this.shopCartList[key].is_specs == 0 && this.shopCartList[key].pd_price_express > 0) {
                  this.expressFee = this.expressFee * 1 + this.shopCartList[key].pd_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.totalExpressFee = this.totalExpressFee * 1 + this.shopCartList[key].pd_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.shopFreightMoney = this.shopFreightMoney * 1 + this.shopCartList[key].pd_price_express * 1 * this.cartShopArr[key].buyNum;
                }
                if (this.shopCartList[key].is_specs == 1 && this.shopCartList[key].sku_price_express > 0 && this.shopCart.length > 0) {
                  this.expressFee = this.expressFee * 1 + this.shopCartList[key].sku_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.totalExpressFee = this.totalExpressFee * 1 + this.shopCartList[key].sku_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.shopFreightMoney = this.shopFreightMoney * 1 + this.shopCartList[key].sku_price_express * 1 * this.cartShopArr[key].buyNum;
                }
                if (this.shopCartList[key].is_specs == 1 && this.shopPaySkuproduc.sku_price_express > 0 && !this.shopCart.length) {
                  this.expressFee = this.expressFee * 1 + this.shopPaySkuproduc.sku_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.totalExpressFee = this.totalExpressFee * 1 + this.shopPaySkuproduc.sku_price_express * 1 * this.cartShopArr[key].buyNum;
                  this.shopFreightMoney = this.shopFreightMoney * 1 + this.shopPaySkuproduc.sku_price_express * 1 * this.cartShopArr[key].buyNum;
                }
                if (this.shopCartList[key].corp_express_status == 1) {
                  //企业利润
                  this.expressFee = this.expressFee * 1 + this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum; //优惠后金额
                  this.totalExpressFee = this.totalExpressFee * 1 + this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum;
                  this.shopFreightMoney = this.shopFreightMoney * 1 + this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum;
                }
                if (this.shopCartList[key].corp_express_status == 2 && this.expressFee > 0) {
                  //企业补贴
                  this.expressFee = this.expressFee * 1 - this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum; //优惠后金额
                  this.totalExpressFee = this.totalExpressFee * 1 - this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum;
                  this.shopFreightMoney = this.shopFreightMoney * 1 - this.shopCartList[key].corp_express_price * 1 * this.cartShopArr[key].buyNum;
                }
              }
              if (this.expressFee < 0) {
                this.expressFee = 0;
              }
              if (this.totalExpressFee < 0) {
                this.totalExpressFee = 0;
              }
              //使用兑换码后 立即支付按钮上方应显示优惠后金额
              typeof this.shopFreightMoney == "undefined" ? (this.shopFreightMoney = this.expressFee) : (this.shopFreightMoney = this.shopFreightMoney);
            } else {
              this.getPayMonet(); //总金额
            }
          } else {
            this.shopFreightMoney = -1;
            if (this.radioSince == 1) {
              //this.$toast(data.data.message);
            }
            this.getPayMonet(); //总金额
          }
        },
      });
    },
    // 判断手机型号
    judgmentModel() {
      let u = navigator.userAgent,
        app = navigator.appVersion;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        console.log("安卓手机");
      }
      if (isIOS) {
        //this.configInfo.returnUrl = `${this.configInfo.ios_scheme}${this.configInfo.returnUrl}`
        console.log("苹果手机");
      }
    },
    isWeixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.payType = 4;
        return true;
      } else {
        // 不是微信环境
        return false;
      }
    },
    // 获取域名
    isDev() {
      if (process.env.NODE_ENV === "development") {
        this.pathDiami = "https://pay.taolai.com";
      } else {
        this.pathDiami = "https://pay.taolai.com";
      }
    },
    // 自提验证码弹框 关闭按钮
    closeDiolad() {
      this.switchPhone = false;
      this.showPhone = false;
    },
    // 地址
    radioAddressBtn() {
      if (this.radioSince == 2) {
        this.shopFreightMoney = 0;
        this.discountExpressFee = 0;
        this.totalExpressFee = 0;

        this.getshopFreight(); //运费
      } else {
        if (this.addressinfo.length > 0) {
          this.getshopFreight(); //运费
        }
        this.getPayMonet();
      }
    },
    // 切换地址  自提或者快递
    getRadioSince() {
      if (this.userInfo.phone != "" && this.userInfo.phone.length == 11) {
        this.showPhone = true;
      } else {
        this.switchPhone = true;
      }
    },
    // 使用手机号
    surePhoneBtn() {
      this.pay();
    },
    // 切换绑定手机号按钮
    cancelPhoneBtn() {
      this.switchPhone = true;
    },
    // 获取验证码
    getCode(phone) {
      this.$axios({
        method: "POST",
        url: "/sms/send",
        data: {
          phone: phone,
        },
        success: (data) => {
          if (data.data.status == "success") {
          } else {
            this.$toast(data.data.message);
          }
        },
      });
      this.verificationCode = 1;
      this.getTime();
    },
    phoneIptBtn() {
      var reg = 11 && /^((13|14|15|16|17|18)[0-9]{1}\d{8})$/;
      if (!reg.test(this.phoneIpt)) {
        this.$toast("手机号格式不正确");
        return;
      }
    },
    // 限制验证码长度
    aptchaInterception() {
      this.codeIpt = this.codeIpt.substring(0, 4);
    },
    beforeSwitchPhone() {
      if (this.phoneIpt != "" && this.codeIpt != "") {
        this.switchPhoneBtn();
      } else {
        this.$toast("请填写手机号及验证码哦..");
      }
    },
    // 确认绑定手机号按钮
    switchPhoneBtn() {
      this.$axios({
        method: "POST",
        url: "/sms/verification",
        data: {
          phone: this.phoneIpt,
          captcha: this.codeIpt,
        },
        success: (data) => {
          if (data.data.status == "success") {
            this.switchPhone = false;
            localStor.save("phoneIpt", this.phoneIpt);
            this.pay();
          } else {
            this.$toast(data.data.message);
          }
        },
      });
    },
    // 倒计时
    getTime() {
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.countdown = 60;
          this.verificationCode = "";
        }
      }, 1000);
    },
    // 倒计时
    getTime2min() {
      this.timer = setInterval(() => {
        if (this.countdown2min > 1) {
          this.countdown2min--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.countdown2min = 120;
          this.corpCode = "";
        }
      }, 1000);
    },
    // 过滤购物车
    filterCartArr() {
      let isNewUser = {};
      this.$fn.getPositionType().then((res) => {
        isNewUser = res;
      });
      let newArr = this.shopCart.map((res) => {
        let obj = {};
        obj.cpPdId = res.cp_pd_id;
        obj.cpSkuId = res.cp_pd_sku;
        obj.buyNum = res.pd_count;
        obj.isNewUser = isNewUser[res.pa_type] || 0;
        if (res.cp_pd_id == this.codeObj.cpPdId) {
          obj.couponUserId = this.codeObj.exchangeCode; //兑换码id
        } else {
          obj.couponUserId = "";
        }
        return obj;
      });
      this.cartShopArr = newArr;
    },
    // 过滤详情过来的数据
    filterMainArr() {
      let obj = {};
      this.cartShopArr = [];
      obj.cpPdId = this.shopPayDetail.id;
      obj.cpSkuId = this.shopPayDetail.skuList ? this.shopPaySkuproduc.cp_sku_id : 0; //有规格传规格 没有规格传0
      obj.buyNum = this.num;
      typeof this.codeObj.exchangeCode != "undefined" ? (obj.couponUserId = this.codeObj.exchangeCode) : (obj.couponUserId = ""); //兑换码id
      this.cartShopArr.push(obj);
    },
    // 立即支付
    payMoney() {
      if (this.$fn.isXLYP(this.configInfo.cp_uid)) {
        this.$fn.showXLYPText();
        return;
      }
      if (this.addressinfo.length == 0 && this.radioSince == 1) {
        this.$toast("请先添加地址哦");
        return;
      }
      if (this.shopFreightMoney == -1 && this.radioSince == 1) {
        this.$toast("该地区不支持配送,请重新选择地址");
        return;
      }
      if (this.isCorpAddress && this.address.area_code != this.corpAreaCode) {
        this.$toast("当前地址不支持配送，请新建地址");
        return;
      }
      if (this.radioSince == 2) {
        this.phoneIptVal = localStor.get("phoneIpt");
        // 手机号为空
        if (JSON.stringify(this.phoneIptVal) == "{}") {
          this.getRadioSince();
        }
        // 自提地址默认以及是否更换
        if (this.checkSinceId == "") {
          this.checkSinceId = this.sinceList[0].address_id;
        } else {
          this.checkSinceId = this.checkSinceId;
        }
        // 手机号不为空
        if (JSON.stringify(this.phoneIptVal) != "{}") {
          this.phoneIpt = this.phoneIptVal;
          this.pay();
        }
      } else {
        let addressId = isAddressId.fetch();
        this.checkAddressId = addressId == "" ? this.addressinfo[0].id : addressId;
        this.pay();
      }
    },
    getPayType() {
      // 1微信 0支付宝
      if (this.payType != 4) {
        //排除微信公众号情况
        if (this.disablePayMode == 0) {
          this.payType = this.payType;
        } else if (this.disablePayMode == 1) {
          this.payType = 0;
        } else if (this.disablePayMode == 2) {
          this.payType = 1;
        }
      }
    },
    // 拆分下单
    pay() {
      if (this.orderId && this.configInfo.is_crop_sms == 1) {
        this.showSms = true;
        this.smsCode = "";
      }
      this.getPayType();
      const that = this;
      wx.miniProgram &&
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            that.payType = 5;
          }
        });
      // 支付按钮防呆
      if (this.flag == 1) {
        return false;
      }
      this.flag = 1;
      //2020-05-19 取消对ios_scheme的判断  this.judgmentModel()
      if (window.history && window.history.pushState) {
        window.addEventListener(
          "popstate",
          function (e) {
            //这里进行跳转操作
          },
          false
        );
      }
      if (JSON.stringify(this.address) == "{}") {
        this.$toast("请您先选择配送地址..");
        this.flag = 0;
        return;
      }

      if (this.$route.query.path != "ShoppingCart" && (this.$route.query.path != "shopAddress" || JSON.stringify(this.shopCart) == "{}")) {
        this.filterMainArr(); //详情页到支付页
      } else {
        this.filterCartArr();
      }
      this.$axios({
        method: "POST",
        url: "/order/placeOrder",
        data: {
          items: JSON.stringify(this.cartShopArr),
          addressId: this.radioSince == 2 ? this.checkSinceId : this.checkAddressId,
          payType: this.payType,
          // couponId: this.couponId ? this.couponId : 0,//优惠券
          returnUrl: this.configInfo.returnUrl,
          pickPhone: this.phoneIpt == "" ? this.userInfo.phone || undefined : this.phoneIpt,
          cartIds: this.goShopId.join(",") || undefined,
          cardPay: this.cardPay || undefined,
        },
        success: (data) => {
          if (data.data.status == "success") {
            this.orderId = data.data.data.orderId;
            this.configInfo.is_crop_sms == 1
              ? (this.showSms = true) // 展示输入验证码弹窗
              : this.payOrder(data.data.data.orderId); //支付 涉及到现金支付的才掉支付接口
            this.configInfo.is_repair_cash == 1 ? this.getPoints() : "";
          }
          if (data.data.status == "error") {
            this.$toast(data.data.message);
            this.flag = 0;
          }
        },
      });
    },

    // 拆分支付
    payOrder(orderId) {
      this.isPayStatus = false;
      const form = {
        orderId: orderId,
        payType: this.payType,
        returnUrl: this.configInfo.returnUrl,
        smsCode: this.smsCode || undefined,
      };
      if (this.payType == 5 && "cp_type" in this.configInfo) {
        // if (this.configInfo.cp_type == 1) {
        //   form.appletsType = 2;
        // }
        //增加小程序支付
        let cpUid = this.configInfo.cp_uid;
        if (cpUid == 10030 || cpUid == 1002) {//淘来优品
          form.appletsType = 2;
        }
        if (cpUid == 1003 || cpUid == 10468) {//对彩旗舰店
          form.appletsType = 3;
        }
      }
      this.$axios({
        method: "POST",
        url: "/order/payOrder",
        data: form,
        success: (data) => {
          if (data.data.status == "success") {
            //记录支付方式，以便在跳转时做相应判断  微信是拉起微信再返回payDialog，支付宝是拉起payDialog再拉起支付
            localStorage.setItem("payType", this.payType);
            if (this.payNumMoney == 0 && this.expressFee == 0 && this.configInfo.is_repair_cash > 0) {
              if (this.shopCartList.length == 0 && Number(this.countPoints) < Number(this.points) + Number(this.cardPayNum)) {
                // 购物车现金补积分纯积分商品逻辑补充
                this.$router.replace({ path: "/orderAll" });
                return;
              }
              if (this.shopCartList.length > 0 && Number(this.payNumMoneyJF) < Number(this.points) + Number(this.cardPayNum)) {
                // 普通商品现金补积分纯积分商品逻辑补充
                this.$router.replace({ path: "/orderAll" });
                return;
              }
            }
            // 非购物车 纯积分 + 运费4
            if (!this.shopCart.length) {
              if (this.payNumMoney == 0 && this.expressFee == 0 && this.configInfo.is_repair_cash == 0) {
                this.$router.replace({ path: "/orderAll" });
                return;
              }
            } else if (this.shopCart.length > 0) {
              // 购物车 购物车总钱数 + 运费
              if (this.countPrice == 0 && this.expressFee == 0 && this.configInfo.is_repair_cash == 0) {
                this.$router.replace({ path: "/orderAll" });
                return;
              }
            }

            if (this.payType == 0) {
              this.$router.replace({
                path: "/payDialog",
                query: {
                  app_id: this.configInfo.app_id,
                },
              });
              setTimeout(function () {
                const div = document.createElement("div");
                div.innerHTML = data.data.data.urlData;
                document.body.appendChild(div);
                document.forms[0].submit();
              }, 300);
              // document.write(data.data.data.urlData);
            }
            if (this.payType == 1) {
              let wxUrlData = data.data.data.urlData;
              location.replace(wxUrlData);
              this.showPay = true;
            }
            if (this.payType == 4) {
              this.payConfig = JSON.parse(data.data.data.urlData);
              location.replace(
                `${process.env.WX_PAY_API}?appId|${this.payConfig.appId}&timeStamp|${this.payConfig.timeStamp}&nonceStr|${this.payConfig.nonceStr}&package|${this.payConfig.package}&signType|${this.payConfig.signType}&paySign|${this.payConfig.paySign}&returnUrl|${this.configInfo.returnUrl}`
              );
              this.showPay = true;
            }
            if (this.payType == 5) {
              const payConfig = JSON.parse(data.data.data.urlData);
              //点击微信支付后，调取统一下单接口生成微信小程序支付需要的支付参数
              this.$router.replace({ path: "/payDialog" });

              const path = `/pages/pay/pay?appId=${payConfig.appId}&timeStamp=${payConfig.timeStamp}&nonceStr=${payConfig.nonceStr}&package=${payConfig.package.replace(/=/g, "")}&signType=${payConfig.signType}&paySign=${payConfig.paySign}`;
              //通过JSSDK的api使小程序跳转到指定的小程序页面
              wx.miniProgram.navigateTo({ url: path });
              this.showPay = true;
            }
          }
          if (data.data.status == "error") {
            this.$toast(data.data.message);
          }
        },
      });
      this.isPayStatus = true;
    },

    // 优惠券
    couponsBtn() {
      this.showList = true;
      this.$axios({
        method: "POST",
        url: "/coupon/use/list",
        data: {
          cpPdId: this.shopPayDetail.id,
        },
        success: (data) => {
          if (data.data.status == "success") {
            this.coupons = data.data.data;
          } else {
            this.$toast(data.data.message);
          }
        },
      });
    },
    // 地址列表
    getAddress() {
      getAddressinfo({
        callBack: (data) => {
          this.addressinfo = data;
          this.showDataAddress = this.addressinfo.length == 0 ? "hideAddress" : "showAddress"; //解决闪屏
          this.address = this.addressinfo.filter((res, i) => {
            return res.id == this.addressId;
          })[0];
          if (this.radioSince == "1" && this.addressinfo.length > 0) {
            this.getshopFreight(); //运费
          }
        },
      });
    },
    // 实时配置
    appConfig(appConfig) {
      // if(appConfig.is_corp_pay_express){
      //   this.isCorpPayExpress = appConfig.is_corp_pay_express || 0
      // };
      if (appConfig.disable_pay_mode) {
        this.disablePayMode = appConfig.disable_pay_mode || 0;
      }
      if (appConfig.disable_pay_mode) {
        this.disablePayMode = appConfig.disable_pay_mode || 0;
      }
    },
    getCorpCode() {
      this.corpCode = 1;
      this.$axios({
        method: "POST",
        url: "/corp/sms/send",
        data: {
          orderId: this.orderId,
        },
        success: (data) => {
          if (data.data.status == "success") {
            this.getTime2min();
          }
        },
      });
    },
    corpPayClick() {
      //this.smsCode.length == 6 ? this.payOrder(this.orderId) : this.$toast('请输入完整验证码')
      if (this.smsCode.length == 6) {
        if (this.isPayStatus) {
          this.payOrder(this.orderId);
        }
      } else {
        this.$toast("请输入完整验证码");
      }
    },
    getPoints() {
      this.$axios({
        method: "POST",
        url: "/corp/points/balance",
        success: (data) => {
          if (data.data.status == "success") {
            this.points = data.data.data;
          }
        },
      });
    },
    hideSms() {
      this.showSms = false;
      this.$router.replace({ path: "/orderAll" });
    },
  },
  watch: {
    switchPhone(newVal, oldVal) {
      if (newVal == false) {
        this.showPhone = false;
      }
    },
  },
};
</script>

<style scoped>
.box {
  background: #eeeeee45;
  margin-bottom: 2rem;
  font-size: 0.24rem;
}

.addressCard {
  font-size: 0.25rem;
  background: #fff;
  padding: 0.1rem 0.2rem;
}

.van-address-list {
  padding-bottom: 0.01rem;
}

.addressCard1 {
  background: #fff;
  display: flex;
  margin-top: 0.15rem;
  padding: 0.2rem;
}

.addressCard1 img {
  max-width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.3rem;
}

.addressCard1 p {
  font-size: 0.24rem;
}

.shopspec3 {
  background: #fff;
  padding: 0 0.1rem 0 0.2rem;
  margin: 0.15rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shopspec3 p {
  font-size: 0.24rem;
  margin: 0.3rem 0.2rem 0.3rem 0;
}

.payType {
  background: #fff;
  padding: 0.2rem;
  margin-bottom: 0.15rem;
}

.payType p {
  font-size: 0.24rem;
  margin-left: 0.2rem;
}

.payType div {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.2rem;
  align-items: center;
}

/* 优惠券卡片 */
.cardCoupn {
  font-size: 0.24rem;
  padding: 0.2rem;
  margin: 0.4rem 0.5rem;
  padding-bottom: 0.2rem;
  margin-bottom: 0.2rem;
  border: 0.01rem solid #ccc;
  border-radius: 0.1rem;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 0.24rem;
}

.block {
  width: 70%;
  background-color: #fff;
  border-radius: 0.1rem;
  padding: 0.2rem 0;
  text-align: center;
  line-height: 0.7rem;
}

.block_p {
  color: #333;
  border-bottom: 0.01rem solid #ccc;
  font-size: 0.24rem;
}

.payP {
  color: #999;
  border-bottom: 0.01rem solid #ccc;
}

.payerror {
  color: #999;
}

.paydialog {
  border-bottom: 0.01rem solid #ccc;
  margin-bottom: 0.1rem;
  padding: 0.1rem;
  text-align: center;
}

.shop-btn {
  height: 0.75rem;
  line-height: 0.75rem;
  background: #ff355c;
  border: none;
  width: 95%;
  margin: 0 2.5% 0.2rem;
  border-radius: 0.08rem;
  color: #fff;
}

.jifenClass {
  font-size: 0.24rem;
  color: rgb(246, 4, 4);
}

.jifenClasst {
  font-size: 0.55rem;
  font-weight: bold;
  color: rgb(246, 4, 4);
}

.userClass {
  border: none;
  text-align: center;
  background: #fff;
  color: #ea4244;
}

.active {
  color: #ea4244;
}

.shopClass {
  line-height: 0.77rem;
  height: 0.77rem;
  border-top: 0.1rem solid #fcfcfc;
  position: fixed;
  bottom: 0.9rem;
  padding-top: 0.12rem;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  width: 100%;
  background: #fff;
}

.box_p {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.box_pt {
  width: 5rem;
  font-size: 0.22rem;
  line-height: 0.35rem;
}

.box-pf {
  padding: 0.2rem 0;
  font-size: 0.22rem;
  color: #bfbfbf;
}

.spece-name {
  max-width: 4rem;
}

.yhqBox {
  display: flex;
  align-self: flex-end;
}

.youhuiquan {
  max-width: 1.4rem;
  height: 0.5rem;
  line-height: 0.3rem;
  padding: 0.1rem;
  font-size: 0.24rem;
  background: red;
  color: #fff;
  border: none;
}

.sinc-smlBox {
  background: #fff;
  margin-top: 0.15rem;
  padding: 0.2rem;
}
.tit {
  text-align: center;
  background: #fff;
  padding: 0.5rem 0 0.2rem;
  font-size: 0.28rem;
}
.since-smlbox {
  background: #fff;
  margin: 0.2rem;
  padding: 0.2rem;
}
.van-dialog {
  width: 85%;
}
.since-box,
.since-box2 {
  padding: 0.2rem 0.5rem 0.3rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #333;
}
.since-box2 {
  padding: 0.5rem 0.3rem;
}
.add-btn {
  position: fixed;
  bottom: 0.1rem;
  height: 0.75rem;
  line-height: 0.75rem;
  color: rgb(255, 255, 255);
  background: #ff355c;
  border-color: #ff355c;
  width: 95%;
  margin: 0 2.5%;
  border-radius: 0.08rem;
}
.showSpecs {
  color: #fff;
}
.surecancel-btn {
  border-radius: 0.08rem;
  border: none;
  background: #ff355c;
  color: #fff;
  padding: 0.1rem 0.4rem;
}
.cancel-btn {
  background: #b2b2b2;
}
.underline {
  text-decoration: line-through;
}
.agreement {
  font-size: 10px;
  margin-left: 0.1rem;
  margin-bottom: 1rem;
  padding: 10px;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/ShopPay.vue